(function () {

  'use strict';

  function pxVariableSelector() {
    return {
      restrict: 'E',
      require: 'ngModel',
      scope: {
        ngChange: '&',
        ngBlur: '&',
        ngDisabled: '=',
        hasError: '=',
        placeholder: '=',
        borderless: '=',
        small: '=',
        inputName: '=',
        variables: '=',
        dates: '=',
        metadata: '=',
        maxLength: '=',
        customPattern: '='/*,
        maxDecimals: '='*/
      },
      templateUrl: 'app/components/settings/workflows/variableSelector/variableSelector.template.html',
      link: function (scope, element, attributes, ngModelController) {

        scope.buttonText = '{ }';
        scope.isMenuVisible = false;

        // Transform model value to view value.
        ngModelController.$formatters.push(function (modelValue) {
          const viewValue = modelValue && convertModelValueToViewValue(modelValue);
          return viewValue ?? '';
        });

        // Assign view value to scope variable.
        ngModelController.$render = function () {
          scope.value = ngModelController.$viewValue;
        };

        // Assign scope variable to model value.
        scope.$watch('value', function () {
          ngModelController.$setViewValue(scope.value);
        });

        // Transform view value to model value.
        ngModelController.$parsers.push(function (viewValue) {
          const modelValue = viewValue && convertViewValueToModelValue(viewValue);
          return modelValue ?? '';
        });

        scope.onClickOutside = function () {
          scope.isMenuVisible = false;
        };

        scope.onClickButton = function () {
          scope.isMenuVisible = !scope.isMenuVisible;
        };

        scope.onMenuItemSelected = function (event, item) {
          scope.isMenuVisible = false;

          let itemName = item.name;
          if (itemName[0] !== '{') {
            itemName = '{' + itemName + '}';
          }

          const inputElement = element.find('input.variable-selector-input')[0];
          const selectionStart = inputElement.selectionStart;
          const selectionEnd = inputElement.selectionEnd;
          inputElement.value = scope.value = scope.value.substring(0, selectionStart) + itemName + scope.value.substring(selectionEnd);
          inputElement.selectionStart = inputElement.selectionEnd = selectionStart + itemName.length;
          inputElement.focus();
        };

        scope.isMenuButtonDisabled = function () {
          return !scope.variables?.length && !scope.dates?.length && !scope.metadata?.length;
        };

        scope.isMetadataAvailable = function () {
          return scope.metadata?.length && scope.metadata.some(item => item.name);
        };

        function convertModelValueToViewValue(modelValue) {
          let viewValue = modelValue;
          if (scope.variables?.length) {
            scope.variables.forEach(variable => {
              viewValue = viewValue.replaceAll(variable.name.toUpperCase(), variable.name);
            });
          }
          if (scope.dates?.length) {
            scope.dates.forEach(date => {
              viewValue = viewValue.replaceAll(date.name.toUpperCase(), date.name);
            });
          }
          if (scope.metadata?.length) {
            scope.metadata.forEach(metadata => {
              const from = '{' + metadata.id + (metadata.type === 'LOOKUP' ? ',0' : '') + '}';
              const to = '{' + metadata.name + '}';
              viewValue = viewValue.replaceAll(from, to);
            });
          }
          return viewValue;
        }

        function convertViewValueToModelValue(viewValue) {
          let modelValue = viewValue;
          if (scope.variables?.length) {
            scope.variables.forEach(variable => {
              modelValue = modelValue.replaceAll(variable.name, variable.name.toUpperCase());
            });
          }
          if (scope.dates?.length) {
            scope.dates.forEach(date => {
              modelValue = modelValue.replaceAll(date.name, date.name.toUpperCase());
            });
          }
          if (scope.metadata?.length) {
            scope.metadata.forEach(metadata => {
              const from = '{' + metadata.name + '}';
              const to = '{' + metadata.id + (metadata.type === 'LOOKUP' ? ',0' : '') + '}';
              modelValue = modelValue.replaceAll(from, to);
            });
          }
          return modelValue;
        }

        const deregisterMetadataRenamedListener = scope.$on('METADATA_RENAMED', function (event, oldName, newName) {
          if (scope.metadata) {
            ngModelController.$viewValue = ngModelController.$viewValue.replaceAll('{' + oldName + '}', '{' + newName + '}');
            ngModelController.$render();
          }
        });

        const deregisterMetadataDeletedListener = scope.$on('METADATA_DELETED', function (event, name) {
          if (scope.metadata) {
            scope.value = scope.value.replaceAll('{' + name + '}', '');
            ngModelController.$setViewValue(scope.value);
          }
        });

        scope.$on('$destroy', function () {
          deregisterMetadataRenamedListener();
          deregisterMetadataDeletedListener();
        });

      }
    };
  }

  pxVariableSelector.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxVariableSelector', pxVariableSelector);

})();
